module.exports = __webpack_public_path__ + "static/media/InProgress.1f509dbd.svg";